import { AnyAction, Reducer } from 'redux';
import {
  CommonInsuranceData,
  GlobalAction,
  GlobalActions,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  updateStateWithCommonInsuranceInfo,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { App } from '@ps20-frontend/frontend-models';
import { Zahlungsart } from '@ps20/bff-models';
import { migrateAngebotsdatum } from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { INITIAL_STATE } from '../initialState';
import { loadAndMigrateVwgState } from '../migrations';

function handleSavedStatesLoaded(state: IAppState, action: AnyAction): IAppState {
  const newState = cloneDeep(state);
  const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
    .payload.savedStatesLoaded;
  const loadedAppState = actionPayload.find(
    loadedState =>
      loadedState.appId === App.VWG_V2 && loadedState.angebotsId === state.angebotsId,
  );

  if (loadedAppState != null) {
    if (isAzam(newState.transientState.role)) {
      if (newState.transientState.isRisikoortVnAdresse) {
        delete loadedAppState.state.risikoort.plz;
        delete loadedAppState.state.risikoort.hausnummer;
        delete loadedAppState.state.risikoort.hausnrzus;
        delete loadedAppState.state.risikoort.ort;
        delete loadedAppState.state.risikoort.strasse;
      }
      delete loadedAppState.state.versicherungsnehmer.geburtsdatum;
      if (state.vertragsoptionen?.zahlungsart === Zahlungsart.MAKLER_INKASSO) {
        delete loadedAppState.state.vertragsoptionen.zahlungsart;
      }
    }
    migrateAngebotsdatum(loadedAppState.state);
    return loadAndMigrateVwgState(
      newState,
      loadedAppState.state,
    );
  } else {
    return state;
  }
}

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.SAVED_STATES_LOADED:
        return handleSavedStatesLoaded(state, action);

      case GlobalActions.ANGEBOTS_ID_RECEIVED: {
        return {
          ...state,
          angebotsId: action.payload,
        };
      }

      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (
          actionPayload.angebotsIds.some(
            angebotsId =>
              angebotsId.appId === App.VWG_V2 && angebotsId.angebotsId === state.angebotsId,
          )
        ) {
          const newState: IAppState = cloneDeep(INITIAL_STATE);
          newState.transientState.role = state.transientState.role;
          newState.versicherungsnehmer.isAssekuranztarif =
            state.versicherungsnehmer.isAssekuranztarif;
          return newState;
        }
        return state;
      }
      case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED: {
        const actionPayload: CommonInsuranceData = action.payload;
        return updateStateWithCommonInsuranceInfo(actionPayload, state, App.VWG_V2);
      }
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.VWG_V2 && actionPayload.angebotsId === state.angebotsId) {
          return actionPayload.appState;
        }
        return state;
      }
      default:
        return reducer(state, action);
    }
  };
